import { useEffect, useState } from "react";
import "../shared/style/css/CookieBanner.css";
import { getConsent, saveConsent, applyStoredConsent, getZone } from "./consent";
import { isPrerender } from "./isPrerender";
import { tx } from "../i18n/fieldMapping";

// Aufzeichnung gibt es nur auf den öffentlichen Seiten (nie in Partner-, Fahrer- und Admin-Bereich)
const RECORDING_ALLOWED = getZone() === "public";

// Öffentliche Funktion, um den Banner später erneut zu öffnen
// (z. B. über den "Cookie-Einstellungen"-Link im Footer),
// damit Nutzer ihre Entscheidung jederzeit ändern können.
export function openCookieSettings() {
  window.dispatchEvent(new Event("open-cookie-settings"));
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [details, setDetails] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [recording, setRecording] = useState(false);

  useEffect(() => {
    // Im react-snap-Snapshot darf der Banner NICHT mit ins HTML: Beim Hydrieren rendert der Client zuerst ohne Banner,
    // ein Banner im vorgerenderten HTML würde einen Hydration-Mismatch auslösen (Seite wird komplett neu aufgebaut).
    if (isPrerender) return;
    applyStoredConsent();
    const c = getConsent();
    // Nur anzeigen, wenn für DIESE Zone noch keine (aktuelle) Entscheidung getroffen wurde
    if (!c.decided) setVisible(true);

    // Erlaubt das erneute Öffnen des Banners (Footer-Link "Cookie-Einstellungen")
    const reopen = () => {
      const cur = getConsent();
      setAnalytics(cur.analytics); setRecording(cur.recording); setDetails(true); setVisible(true);
    };
    window.addEventListener("open-cookie-settings", reopen);
    return () => window.removeEventListener("open-cookie-settings", reopen);
  }, []);

  const finish = (a, r) => { saveConsent({ analytics: a, recording: r }); setVisible(false); setDetails(false); };

  if (!visible) return null;

  return (
    <div className="cookieBanner" role="dialog" aria-label="Cookie-Hinweis">
      <div className="cookieBannerCard">
        <div className="cookieBannerHeader">
          <div className="cookieBannerIcoWrap">
            <svg className="cookieBannerIco" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />
              <circle cx="8.5" cy="10.5" r="0.5" fill="currentColor" />
              <circle cx="13" cy="14" r="0.5" fill="currentColor" />
              <circle cx="9.5" cy="15.5" r="0.5" fill="currentColor" />
            </svg>
          </div>
          <span className="cookieBannerTitle">{tx("Cookie-Einstellungen")}</span>
        </div>

        <p className="cookieBannerText">
          {tx("Wir nutzen notwendige Technik für den Betrieb der Website. Mit Ihrer Einwilligung verwenden wir außerdem Statistik (Google Analytics)")}{RECORDING_ALLOWED ? tx(" und eine Sitzungsaufzeichnung") : ""}{tx(", um die Website zu verbessern")}{RECORDING_ALLOWED ? tx(" und Fehler zu finden. Bei der Aufzeichnung werden Eingabefelder maskiert") : ""}{tx(". Ihre Auswahl können Sie jederzeit über den Link")}{" "}
          <button type="button" className="cookieBannerInlineLink" onClick={() => { setAnalytics(getConsent().analytics); setRecording(getConsent().recording); setDetails(true); }}>
            {tx("Cookie-Einstellungen")}
          </button>{" "}
          {tx("im Footer ändern. Weitere Informationen finden Sie in unserer")}{" "}
          <a href="/datenschutz" target="_blank" rel="noopener noreferrer">{tx("Datenschutzerklärung")}</a>{tx(", unserem")}{" "}
          <a href="/impressum" target="_blank" rel="noopener noreferrer">{tx("Impressum")}</a> {tx("und unseren")}{" "}
          <a href="/agb" target="_blank" rel="noopener noreferrer">{tx("AGB")}</a>.
        </p>

        {details && (
          <div className="cookieBannerOptions">
            <label className="cookieBannerOption">
              <input type="checkbox" checked disabled />
              <span><strong>Notwendig</strong> {tx("– für Buchung, Sicherheit und Sitzung (immer aktiv)")}</span>
            </label>
            <label className="cookieBannerOption">
              <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />
              <span><strong>Statistik</strong> – Google Analytics, anonyme Nutzungsstatistik</span>
            </label>
            {RECORDING_ALLOWED && <label className="cookieBannerOption">
              <input type="checkbox" checked={recording} onChange={(e) => setRecording(e.target.checked)} />
              <span><strong>Aufzeichnung</strong> {tx("– Ihre Bedienung der Seite (Klicks, Scrollen) wird anonymisiert aufgezeichnet, Eingaben sind maskiert")}</span>
            </label>}
          </div>
        )}

        <div className="cookieBannerActions">
          <button className="cookieBannerBtn cookieBannerBtnDecline" onClick={() => finish(false, false)}>{tx("Ablehnen")}</button>
          {details ? (
            <button className="cookieBannerBtn cookieBannerBtnSecondary" onClick={() => finish(analytics, recording)}>{tx("Auswahl bestätigen")}</button>
          ) : (
            <button className="cookieBannerBtn cookieBannerBtnSecondary" onClick={() => setDetails(true)}>{tx("Auswahl")}</button>
          )}
          <button className="cookieBannerBtn cookieBannerBtnAccept" onClick={() => finish(true, RECORDING_ALLOWED)}>{tx("Alle akzeptieren")}</button>
        </div>
      </div>
    </div>
  );
}
